import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a99a389e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a99a389e')) {
      api.createRecord('a99a389e', component.options)
    } else {
      api.reload('a99a389e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a99a389e&", function () {
      api.rerender('a99a389e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CryTmaWByxsG/JS/offershelp.vue"
export default component.exports